"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _bind2 = _interopRequireDefault(require("classnames/bind"));

var _ListSelection = _interopRequireDefault(require("./_ListSelection"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _withStyles = _interopRequireDefault(require("../utils/withStyles"));

var _react = _interopRequireWildcard(require("react"));

var _list = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/list.css") : void 0);

var classnames = (0, _bind.default)(_bind2.default).call(_bind2.default, _list.default);

var ListItem = function ListItem(_ref) {
  var _classnames;

  var action = _ref.action,
      buttonProps = _ref.buttonProps,
      className = _ref.className,
      children = _ref.children,
      cssNamespace = _ref.cssNamespace,
      hasByline = _ref.hasByline,
      onClick = _ref.onClick,
      navigation = _ref.navigation,
      partialNavigation = _ref.partialNavigation,
      selected = _ref.selected,
      url = _ref.url,
      props = (0, _objectWithoutProperties2.default)(_ref, ["action", "buttonProps", "className", "children", "cssNamespace", "hasByline", "onClick", "navigation", "partialNavigation", "selected", "url"]);

  var _useState = (0, _react.useState)(selected || false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      selectedState = _useState2[0],
      setSelectedState = _useState2[1];

  var handleClick = function handleClick(e) {
    onClick(e);
  };

  var isLink = navigation || partialNavigation && url;
  var ListItemClasses = classnames("".concat(cssNamespace, "-list__item"), (_classnames = {}, (0, _defineProperty2.default)(_classnames, "".concat(cssNamespace, "-list__item--link"), isLink), (0, _defineProperty2.default)(_classnames, "".concat(cssNamespace, "-list__item--action"), action), _classnames), className);
  var content, selectionProps;

  if (hasByline) {
    content = /*#__PURE__*/_react.default.createElement("div", {
      className: classnames("".concat(cssNamespace, "-list__content"))
    }, children);
  } else if (isLink) {
    var _classnames2;

    var linkClassNames = classnames("".concat(cssNamespace, "-list__link"), (_classnames2 = {}, (0, _defineProperty2.default)(_classnames2, "".concat(cssNamespace, "-list__link--navigation-indicator"), partialNavigation), (0, _defineProperty2.default)(_classnames2, 'is-selected', selected), _classnames2));
    content = /*#__PURE__*/_react.default.createElement("a", {
      className: linkClassNames,
      href: url,
      tabIndex: "0"
    }, children);
  } else if (action) {
    content = /*#__PURE__*/_react.default.createElement("button", (0, _extends2.default)({}, buttonProps, {
      className: classnames("".concat(cssNamespace, "-list__title")),
      onClick: handleClick
    }), children);
  } else {
    var _context;

    content = (0, _map.default)(_context = _react.default.Children).call(_context, children, function (child) {
      var _child$type;

      if ((child === null || child === void 0 ? void 0 : (_child$type = child.type) === null || _child$type === void 0 ? void 0 : _child$type.displayName) === _ListSelection.default.displayName) {
        selectionProps = {
          'role': 'option',
          'aria-selected': selectedState
        };
        return /*#__PURE__*/_react.default.cloneElement(child, {
          selected: selected || selectedState,
          onChange: function onChange(e, checked) {
            var _child$props, _child$props$onChange;

            setSelectedState(checked);
            child === null || child === void 0 ? void 0 : (_child$props = child.props) === null || _child$props === void 0 ? void 0 : (_child$props$onChange = _child$props.onChange) === null || _child$props$onChange === void 0 ? void 0 : _child$props$onChange.call(_child$props, e, checked);
          }
        });
      }

      return child;
    });
  }

  var disableListItemOnClick = isLink || action;
  return /*#__PURE__*/_react.default.createElement("li", (0, _extends2.default)({
    tabIndex: isLink || action ? '-1' : '0'
  }, props, selectionProps, {
    className: ListItemClasses,
    onClick: disableListItemOnClick ? null : handleClick
  }), content);
};

ListItem.displayName = 'List.Item';
process.env.NODE_ENV !== "production" ? ListItem.propTypes = {
  /** Set to true if list item is a button that will trigger an action */
  action: _propTypes.default.bool,

  /** Props to pass to the action button */
  buttonProps: _propTypes.default.object,

  /** Node(s) to render within the component */
  children: _propTypes.default.node,

  /** CSS class(es) to add to the element */
  className: _propTypes.default.string,

  /** Internal use only */
  hasByline: _propTypes.default.bool,

  /** Internal use only */
  navigation: _propTypes.default.bool,

  /** Internal use only */
  partialNavigation: _propTypes.default.bool,

  /** Set to **true** if list item is currently selected (only supported for links and List.Selection) */
  selected: _propTypes.default.bool,

  /** URL to navigate to if list item is a link */
  url: _propTypes.default.string,

  /**
   * Callback function; triggered when user clicks on the list item i.e. `<li>`
   *
   *  (not supported for links as they are supposed to navigate).
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent. See https://reactjs.org/docs/events.html.
   * @returns {void}
   */
  onClick: _propTypes.default.func
} : void 0;
ListItem.defaultProps = {
  onClick: function onClick() {},
  selected: false
};

var _default = (0, _withStyles.default)(ListItem);

exports.default = _default;